export function inputToCents(input) {
  const sanitizedValue = input.replace(/\s+|€/g, '').replace(',', '.');
  const parsedValue = parseFloat(sanitizedValue);
  if (Number.isNaN(parsedValue)) return sanitizedValue;

  return Math.round(parsedValue * 100);
}

export function numberToCurrency(cents, locale, currency) {
  if (typeof cents !== 'number' || isNaN(cents)) {
    cents = 0;
  }
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}

export function localizeAmount(cents) {
  if (!cents) return undefined;

  return numberToCurrency(cents, 'de-DE', 'EUR');
}
